<template>
  <div class="stats-counter" ref="statsCounterRef">
    <p class="stats-counter__value" :class="valueClass">{{ nFormatter(transitionValue, digits) }}</p>
    <p class="stats-counter__title" :class="titleClass">{{ title }}</p>
  </div>
</template>

<script setup lang="ts">
export interface StatsCounterProps {
  title: string,
  value: number,
  titleClass?: string,
  valueClass?: string,
  digits?: number,
  animateOnce?: boolean,
}
const props = withDefaults(defineProps<StatsCounterProps>(), {
  animateOnce: true,
  digits: 2,
});

const alreadyAnimated = ref<boolean>(false);

const statsCounterRef = ref<HTMLDivElement | null>(null);
const isVisible = useElementVisibility(statsCounterRef);

const transitionValue = ref(props.value);

const animateValue = (start: number, end: number, duration: number, intervalTime: number = 25) => {
  const increment = (end - start) / (duration / intervalTime); // Update every 100ms
  let currentValueLocal = start;
  const interval = setInterval(() => {
    currentValueLocal += increment;
    if ((increment > 0 && currentValueLocal >= end) || (increment < 0 && currentValueLocal <= end)) {
      currentValueLocal = end;
      clearInterval(interval);
    }
    transitionValue.value = currentValueLocal;
  }, intervalTime);
};


watch(() => props.value, (newValue) => {
  if (isVisible.value) {
    animateValue(transitionValue.value, newValue, 1000);
  }
});

watch(isVisible, (visible) => {
  if (visible && (!props.animateOnce || !alreadyAnimated.value)) {
    animateValue(0, props.value, 750); // Animate from 0 to the initial value over 1 second
    alreadyAnimated.value = true;
  }
});
</script>

<style lang="scss">
.stats-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;

  min-width: 240px;

  &__value {
    color: #ffffff;
    font-family: var(--font-family-main);
    font-size: 48px;
    font-weight: 900;
    text-align: center;
    white-space: nowrap;
  }

  &__title {
    color: #ffffff;
    font-family: var(--font-family-main);
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    white-space: nowrap;
    text-transform: uppercase;
  }
}
</style>
